type IconProps = {
	width?: number;
	height?: number;
	maskColor?: string;
	color?: string;
}

export const RCWeightIcon = (props: IconProps) => {
	const {
		width = 13,
		height = 14,
		color = '#010A26'
	} = props;
	return (
		<svg role={'img'} width={width} height={height} viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M1.69985 12.25H10.6998L9.6311 4.75H2.7686L1.69985 12.25ZM6.19985 3.25C6.41235 3.25 6.59047 3.17813 6.73422 3.03438C6.87797 2.89063 6.94985 2.7125 6.94985 2.5C6.94985 2.2875 6.87797 2.10938 6.73422 1.96563C6.59047 1.82188 6.41235 1.75 6.19985 1.75C5.98735 1.75 5.80922 1.82188 5.66547 1.96563C5.52172 2.10938 5.44985 2.2875 5.44985 2.5C5.44985 2.7125 5.52172 2.89063 5.66547 3.03438C5.80922 3.17813 5.98735 3.25 6.19985 3.25ZM8.3186 3.25H9.6311C10.0061 3.25 10.3311 3.375 10.6061 3.625C10.8811 3.875 11.0498 4.18125 11.1123 4.54375L12.1811 12.0438C12.2436 12.4938 12.128 12.8906 11.8342 13.2344C11.5405 13.5781 11.1623 13.75 10.6998 13.75H1.69985C1.23735 13.75 0.859221 13.5781 0.565471 13.2344C0.271721 12.8906 0.156096 12.4938 0.218596 12.0438L1.28735 4.54375C1.34985 4.18125 1.5186 3.875 1.7936 3.625C2.0686 3.375 2.3936 3.25 2.7686 3.25H4.0811C4.0436 3.125 4.01235 3.00313 3.98735 2.88438C3.96235 2.76562 3.94985 2.6375 3.94985 2.5C3.94985 1.875 4.1686 1.34375 4.6061 0.90625C5.0436 0.46875 5.57485 0.25 6.19985 0.25C6.82485 0.25 7.3561 0.46875 7.7936 0.90625C8.2311 1.34375 8.44985 1.875 8.44985 2.5C8.44985 2.6375 8.43735 2.76562 8.41235 2.88438C8.38735 3.00313 8.3561 3.125 8.3186 3.25Z' fill={color} />
		</svg>
	);
};
